import React, { ChangeEvent } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormSelect,
  CFormSwitch,
  CRow,
  CTabContent,
} from '@coreui/react-pro'
import { useExchanger } from './hooks'
import { setExchanger, submitEditExchanger } from './model'
import { path } from '../../../libs'
import { CheckCircleOutlined, CloseSquareOutlined } from '@ant-design/icons'

const TYPE = [
  {
    id: 1,
    name: 'exchanger',
  },
  {
    id: 2,
    name: 'partner',
  },
]

export const EditExchanger = () => {
  const { exchanger, loading } = useExchanger()

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setExchanger({
      ...exchanger,
      [event.currentTarget.name]: value,
    })
  }

  if (loading) {
    return <div>Downloading</div>
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Edit exchanger</strong>
      </CCardHeader>
      <CCardBody>
        <CTabContent className="pt-3">
          <p>{exchanger.name}</p>
          <p>
            <a href={path.clients.details(String(exchanger.owner.clientId))}>
              {' '}
              {exchanger.owner.clientId} {exchanger.owner.fullName}
            </a>
          </p>
          <CForm>
            <CCol className="mb-3">
              <span>Is test: </span>
              {exchanger.owner.isTest ? (
                <CheckCircleOutlined className={'text-success'} />
              ) : (
                <CloseSquareOutlined className={'text-danger'} />
              )}
            </CCol>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  label="Name"
                  id="frontName"
                  name="frontName"
                  value={exchanger.frontName}
                  onChange={handleChange}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  label="Internal name"
                  id="internalName"
                  name="internalName"
                  value={exchanger.internalName}
                  onChange={handleChange}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormSwitch
                  label="Activate exchanger"
                  id="active"
                  name="active"
                  type="checkbox"
                  checked={exchanger.active}
                  onChange={handleChange}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormSelect
                  label="Type"
                  id="type"
                  name="type"
                  onChange={handleChange}
                >
                  <option>Choose source type</option>
                  {TYPE.map((type) => (
                    <option
                      value={type.name}
                      selected={type.name == exchanger.type}
                    >
                      {type.name}
                    </option>
                  ))}
                </CFormSelect>{' '}
              </CCol>
            </CRow>
            <CButton
              className="mb-3"
              disabled={loading}
              onClick={() => {
                submitEditExchanger({
                  id: exchanger.id,
                  name: exchanger.name,
                  frontName: exchanger.frontName,
                  internalName: exchanger.internalName,
                  type: exchanger.type,
                  active: exchanger.active,
                  owner: exchanger.owner,
                })
              }}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Save
            </CButton>
          </CForm>
        </CTabContent>
      </CCardBody>
    </CCard>
  )
}
